import { For, Show } from 'solid-js';
import { ErrorCatcher } from '../../tools/error-catcher';
import { FaqItem, FaqItemType } from './faq-item';

type FaqSelectorProps = {
    heading: string;
    faqItems: FaqItemType[];
};

export const FaqSelector = (props: FaqSelectorProps) => {
    const faqItems = () => props.faqItems ?? [];

    return (
        <ErrorCatcher componentName="FaqSelector">
            <div class="my-cvi-8 tablet:my-cvi-10 flex flex-col gap-cvi-6">
                <Show when={props.heading}>
                    <h2 class="heading-xl font-cvi-medium m-0 text-cvi-fg-default">
                        {props.heading}
                    </h2>
                </Show>

                <Show when={faqItems().length > 0}>
                    <ul class="m-0 flex list-none flex-col gap-cvi-6 p-0">
                        <For each={faqItems()}>{(faqItem) => (
                            <FaqItem faqItem={faqItem} />
                        )}</For>
                    </ul>
                </Show>
            </div>
        </ErrorCatcher>
    );
};

FaqSelector.parseProps = (atts: any) => {
    return {
        heading: atts.heading,
        faqItems: atts.faqItems,
    };
};
